import styled from 'styled-components';
import { token } from '@bynder/design-system';

export const NotificationPopupContainer = styled.div`
    position: fixed;
    z-index: 1050;
    display: block;
    width: 100%;
    max-width: 500px;
    height: auto;
    top: 10px;
    left: 50%;
    transform: translateX(-50%) scale(0);
    transform-origin: top center;
    transition: transform 0.5s ease;
    border-radius: 4.8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
    outline: 0;

    &.active {
        transform: translateX(-50%) scale(1);
    }
`;

export const NotificationPopupContent = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    background: ${token.white};
    border-radius: 4.8px;
`;

export const NotificationPopupHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px;
    box-shadow: 0 1px 6px -2px ${token.colorShadow};
    border-bottom: 1px solid ${token.gray200a};
    border-top-left-radius: 4.8px;
    border-top-right-radius: 4.8px;
`;

export const NotificationPopupTitle = styled.h5`
    margin: 0 0 10px;
    font-size: 17.5px;
    font-weight: 600;
    line-height: 1.2;
`;

export const NotificationPopupCloseButton = styled.button`
    padding: 0;
    margin: 0;
    background-color: transparent;
    border: 0;
    font-size: 21px;
    font-weight: 600;
    line-height: 1;
    color: #000;
    opacity: 0.5;

    &:hover,
    &:focus {
        opacity: 0.75;
    }
`;

export const NotificationPopupBody = styled.div`
    padding: 10px 15px;
`;

export const NotificationPopupText = styled.p`
    margin: 0;
`;

export const NotificationPopupFooter = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    padding: 10px 15px;
    border-bottom-right-radius: 4.8px;
    border-bottom-left-radius: 4.8px;

    > * {
        margin: 4px;
    }
`;
